import {
    PUSH_FOLLOWERS,
    CLEAR_PROFILE_FOLLOWERS,
    UPDATE_FOLLOWER
} from "@/store/mutations.type"

const StateKey = 'profileFollowers'

export default {
    [CLEAR_PROFILE_FOLLOWERS](state) {
        state[StateKey] = []
        state[`${StateKey}Offset`] = 0
        state[`${StateKey}FetchCompleted`] = false
    },

    [PUSH_FOLLOWERS](state, followers) {
        if (followers.length) {
            followers.forEach((follower) => {
                if (follower) state[StateKey].push(follower)
            })
        }
        if (followers.length === state[`${StateKey}Limit`]) {
            state[`${StateKey}Offset`] += state[`${StateKey}Limit`]
        } else {
            state[`${StateKey}FetchCompleted`] = true
        }
    },

    [UPDATE_FOLLOWER](state, payload) {
        const user = state[StateKey].find(user => user.id === payload.userId)
        if(user) Object.assign(user, payload.value)
    }
}